/**
 * Get the Auth0 access token from localStorage.
 * Checks both the password-grant token and the Auth0 SPA SDK cache.
 */
export function getAuthToken(): string | null {
  try {
    // 1. Check for password-grant token (stored by auth0-context.tsx loginWithPassword)
    const directToken = localStorage.getItem('auth_access_token');
    if (directToken) {
      const expiry = localStorage.getItem('auth_token_expiry');
      if (!expiry || Date.now() < Number(expiry)) {
        return directToken;
      }
    }

    // 2. Check Auth0 SPA SDK cache
    const keys = Object.keys(localStorage);
    const auth0Key = keys.find(
      (key) => key.startsWith('@@auth0spajs@@') && key.includes('::default::')
    );
    if (auth0Key) {
      const data = JSON.parse(localStorage.getItem(auth0Key) || '{}');
      const token = data?.body?.access_token;
      if (token) return token;
    }
  } catch {
    // Ignore localStorage errors (SSR, private browsing, etc.)
  }

  return null;
}

/**
 * Get authorization headers for API requests.
 * Returns an object with the Authorization header, or an empty object if not authenticated.
 */
export function getAuthHeaders(): Record<string, string> {
  const token = getAuthToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}
